import { Component, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-errors',
  template: `
    <p style="color: red; text-indent: 0; font-size: 13px; margin-top: 4px;" *ngIf="showErrors()">
     {{errors()}}
    </p>
  `,
  standalone: false
})
export class ErrorComponent {

  @Input()
  private control: AbstractControlDirective | AbstractControl;
  @Input()
  private errorMessages;

  public showErrors(): boolean {
    return this.control &&
      this.control.errors &&
      (this.control.dirty || this.control.touched);
  }

  public errors(): string[] {
    const errorMessage = Object.keys(this.control.errors)
      .map(field => this.errorMessages[field]);
    return errorMessage[0];
  }

}
